<template>

  <div>
    <a class="social linked-in" :href="linkedIn" target="_blank" >
      <v-icon :large="true">mdi-linkedin-box</v-icon>
    </a>
    <a class="social twitter" :href="twitter" target="_blank" >
      <v-icon :large="true">mdi-twitter-box</v-icon>
    </a>
    <a class="social facebook" @click="fb">
      <v-icon :large="true">mdi-facebook-box</v-icon>
    </a>
  </div>
</template>
<script>
export default {
  props: ["link"],
  methods: {
    fb() {
      // eslint-disable-next-line no-undef
      FB.ui({
        method: "share",
        href: this.fullLink
      });
    }
  },
  computed: {
    fullLink() {
      return `${window.location.origin}${this.link}`;
    },
    linkedIn() {
      return (
        "https://www.linkedin.com/shareArticle?mini=true&src=https://habittechnologies.com&url=" +
        this.fullLink
      );
    },
    twitter() {
      return "https://twitter.com/intent/tweet?url=" + this.fullLink; // + "text=" + prefillCopy
    }
  }
};
</script>
<style lang="less">
.social {
  text-decoration: none;
}
.linked-in {
  i {
    color: white ;
  }
}
.twitter {
  i {
    color: white ;
  }
}
.facebook {
  i {
    color: white ;
  }
}
</style>
